import React from "react";
import {createContext} from "react";
import {useCollectionData} from "react-firebase-hooks/firestore";
import Firebase from "firebase/app";
import "firebase/firestore";

export const BuildingContext = createContext(undefined);

export const BuildingProvider = (props: any) => {
    const [buildingInfo] = useCollectionData(
        Firebase
            .firestore()
            .collection('Buildings')
    );
    let buildings: any = [];

    if (buildingInfo) {
        buildings = buildingInfo.map((data: any) => {
            const {
                Address,
                BuildingCode,
                BuildingLocation,
                BuildingOutline,
                Coordinates,
                Type,
                URL,
            } = data;

            return {
                address: Address,
                code: BuildingCode,
                location: BuildingLocation,
                outline: BuildingOutline.split(","),
                coordinates: Coordinates.split(","),
                type: Type.split(","),
                url: URL,
            };
        });
    }

    return (
        <BuildingContext.Provider value={buildings}>
            {props.children}
        </BuildingContext.Provider>
    );
};